<section>
    <span c-activity-log-blurb activity="activity"></span>{{"setOwnerLog.message"|translate}}
    <span class="tag">{{Owner}}</span>
    <div c-activity-log-message activity="activity"></div>
</section>